<template>
  <BModal
    :model-value="visible"
    title="Confirm Password Reset"
    ok-title="Reset Password"
    cancel-title="Cancel"
    @update:model-value="$emit('update:visible', $event)"
    @ok="$emit('confirm')"
  >
    <p>Are you sure you want to reset the password for this user?</p>
    <p class="text-muted small">
      A new temporary password will be generated.
    </p>
  </BModal>
</template>

<script setup lang="ts">
import { BModal } from "bootstrap-vue-next";

defineProps<{
  visible: boolean;
}>();

defineEmits<{
  "update:visible": [value: boolean];
  confirm: [];
}>();
</script>
